<script setup lang="ts">
// import IcoChevronRight from '@/components/icons/IconChevronRight.vue';
import { inject } from 'vue';
import { type Config } from '@/types/config';

const config = inject('config') as Config;

const envVar: String = config.env
const policyHref = envVar.indexOf('.') == -1 ? `${envVar}policy.americanstrategic.com/Policy/Menu.aspx` : `https://policy${envVar}.americanstrategic.com/Policy/Menu.aspx`;
const portalHref = envVar.indexOf('.') == -1 ? `${envVar}portal.asipolicy.com` : `https://portal${envVar}.asipolicy.com`;
</script>

<template>
    <div id="skipToContent" class="container-fluid container-body container-home pb-5 position-relative">
        <div class="row">
            <div class="col-12 text-center mt-5">
                <h1 class="h1 fw-bold">We've moved!</h1>
                <p class="fs-4">Progressive Home Insurance now lives at Progressive.com</p>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 col-md-8 text-center">
                <p class="bg-light pt-3 pb-3">
                    Log into your policy, see property insurance offerings, and more over at
                    <a href="https://www.progressive.com/" class="link-underline">Progressive.com</a>
                </p>
            </div>
        </div>
        <div class="row mt-5 justify-content-md-center container-card-home">
            <div class="col-12 col-md-4 col-xl-3">
                <router-link :to="{ name: 'reportaclaim' }" class="card card-home text-center fw-bold">
                    <span class="link-text">Report a Claim</span>
                </router-link>
            </div>
            <div class="col-12 col-md-4 col-xl-3">
                <router-link :to="{ name: 'floodinsurance' }" class="card card-home text-center fw-bold">
                    <span class="link-text">Flood Information</span>
                </router-link>
            </div>
        </div>
        <div class="row mb-5 justify-content-md-center container-card-home">
            <div class="col-12 col-md-4 col-xl-3">
                <a :href="policyHref" class="card card-home text-center fw-bold">
                    <span class="link-text">Agent Login</span>
                </a>
            </div>
            <div class="col-12 col-md-4 col-xl-3">
                <a v-bind:href="portalHref" class="card card-home text-center fw-bold">
                    <span class="link-text">Flood Policy Login</span>
                </a>
            </div>
        </div>
        <div class="row-images-home">
            <img src="@/assets/images/svg/mma_summer-home-mowing_illustration-left.svg" alt=""
                class="body-image-left" />

            <img src="@/assets/images/svg/mma_spring-home-illustration-right.svg" alt="" class="body-image-right" />
        </div>
    </div>
</template>

<style>
.ico-chevron {
    display: inline-block;
    float: left;
    padding-left: 0.5em;
    width: 15px;
}

.card-home:hover .link-text:after {
    left: 14px;
}

.link-text:after {
    background-image: url(/src/assets/images/svg/ico-chevron-right.svg);
    background-repeat: no-repeat;
    content: '';
    display: inline-block;
    height: 10px;
    width: 8px;
    left: 8px;
    position: relative;
    transition: all 0.1s ease;
}

h1.h1 {
    font-size: 3rem;
}
</style>
